import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '@babel/types';
import { RADIO_COLORS as COLORS } from '../constants';
function RadioButton({ data, name, selected, onValueChange, allDisabled }) {
    return (
        <div className="groupRadio">
            {data.map((item) => {
                return (
                    <div
                        className={`customradioButtons radio-${item.color} ${
                            allDisabled ? 'disabled' : ''
                        }`}
                        key={item.key}
                    >
                        <input
                            type="radio"
                            id={item.id}
                            name={name}
                            value={item.value}
                            onChange={() => onValueChange(item.value)}
                            checked={selected == item.value ? true : false}
                            disabled={allDisabled}
                        />
                        <label
                            htmlFor={item.id}
                            className={allDisabled ? 'disabled' : ''}
                        >
                            {item.label}
                        </label>
                    </div>
                );
            })}
        </div>
    );
}

RadioButton.propTypes = {
    // An array of objects to generate the radio button group
    data: PropTypes.arrayOf(
        PropTypes.shape({
            // Key for the each radio button as required by the react to differentiate between the same component
            key: PropTypes.number.isRequired,

            // To display the label for each radio button
            label: PropTypes.string,

            // To perform actions on each perticular radio button
            id: PropTypes.number.isRequired,

            // To select the color of the radio button to be displayed from the given volors
            color: PropTypes.oneOf(COLORS).isRequired,
        }),
    ).isRequired,

    // The name of the radio button group to differentiate between the differents radio button groups
    name: PropTypes.string.isRequired,

    // To indicate currently selected value
    selected: PropTypes.string,

    // To invoke a function on change of the value
    onValueChange: PropTypes.func,
    allDisabled: PropTypes.bool,
};

RadioButton.defaultProps = {
    label: null,
    onClick: noop,
    selected: null,
    onValueChange: noop,
    allDisabled: false,
};

export default RadioButton;
